import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b358d26c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-column align-center" }
const _hoisted_2 = { class: "page-title mb-3 text-left" }
const _hoisted_3 = { class: "nav-container mt-3" }

import { computed, onMounted, ref } from "vue";
import { useCourseStore } from "@/store/courseStore";
import axios from "axios";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import DailyMilestoneBar from "@/components/DailyMilestoneBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WordsView',
  setup(__props) {

const correctAnswerClicked = ref(false);
const incorrectAnswerClicked = ref(false);
const clickedButton = ref("");

const router = useRouter();
const dialogMessage = ref("");
const displayPopup = ref(false);

const courseStore = useCourseStore();
const courseName = courseStore.currentCourse?.name;
const topicName = courseStore.currentTopic?.name;
const courseType = courseStore.currentCourse?.type;
const isSchoolUser = computed(() => courseStore.isSchoolUser);

const topic = ref();
const learnedWords = ref(0);
const totalWords = ref(0);
const topicProgressPercentage = ref("0");

const { t } = useI18n();

onMounted(async () => {
  await fetchNewWord();
  await getTopic();
});

async function fetchNewWord() {
  correctAnswerClicked.value = false;
  incorrectAnswerClicked.value = false;
  clickedButton.value = "";

  try {
    const response = await axios.get(
      `api/course/${courseStore.currentCourse?.id}/topics/${courseStore.currentTopic?.id}/word`,
    );

    if (
      response.status === 200 &&
      (!response.data || Object.keys(response.data).length === 0)
    ) {
      displayPopup.value = true;
      dialogMessage.value = t("wordsView.allLearnedMessage");
      setTimeout(() => {
        displayPopup.value = false;
        router.push("/course");
      }, 3000);
      return;
    }
    // console.log(response.data);

    wordId.value = response.data.id;
    word.value = response.data.valueRu;
    correctAnswer.value = response.data.id;
    button1.value = response.data.wordOptions[0];
    button2.value = response.data.wordOptions[1];
    button3.value = response.data.wordOptions[2];
    button4.value = response.data.wordOptions[3];
  } catch (error) {
    console.error("Failed to fetch words", error.message);
  }
}

async function getTopic() {
  try {
    const response = await axios.get(
      `api/course/${courseStore.currentCourse?.id}/topics`,
    );
    const topics = response.data;

    //Find the current topic from the list of received topics
    topic.value = topics.find(
      (topic) => topic.id === courseStore.currentTopic?.id,
    );

    if (topic.value) {
      learnedWords.value = topic.value.completedWords || 0;
      totalWords.value = topic.value.wordCount || 0;
      topicProgressPercentage.value = totalWords.value
        ? Math.min((learnedWords.value / totalWords.value) * 100, 100).toFixed(
            1,
          )
        : "0";
      window.dispatchEvent(new Event("update-progress"));
    } else {
      console.error("Failed to find current topic in the list");
    }
  } catch (error) {
    console.error("Failed to fetch topics", error.message);
  }
}

const word = ref("");
const wordId = ref("");
const correctAnswer = ref("");
const button1 = ref({ id: "", value: "" });
const button2 = ref({ id: "", value: "" });
const button3 = ref({ id: "", value: "" });
const button4 = ref({ id: "", value: "" });
const buttonList = [button1, button2, button3, button4];

const checkAnswer = async (selectedAnswer: { id: string; value: string }) => {
  if (correctAnswerClicked.value || incorrectAnswerClicked.value) return;
  clickedButton.value = selectedAnswer.value;
  try {
    // console.log("Selected Answer:", selectedAnswer);
    // console.log("Correct Answer:", correctAnswer);
    // console.log("wordId:", wordId.value);

    const response = await axios.post(
      `api/course/${courseStore.currentCourse.id}/topics/${courseStore.currentTopic.id}/word`,
      {
        wordId: wordId.value,
        guessId: selectedAnswer.id,
      },
    );
    correctAnswer.value = response.data.correctValueId;

    // console.log(response.data);

    if (response.data.guessStatus === "CORRECT") {
      correctAnswerClicked.value = true;
      await getTopic();
    } else {
      incorrectAnswerClicked.value = true;
    }
  } catch (error) {
    console.error("Failed to check guess", error.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_dialog, {
        modelValue: displayPopup.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayPopup).value = $event)),
        "max-width": "600px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { variant: "elevated" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(dialogMessage.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(DailyMilestoneBar),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(courseName)) + ". " + _toDisplayString(_unref(topicName)), 1),
          (correctAnswerClicked.value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: "green-darken-2",
                size: "50px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-check-circle-outline")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (incorrectAnswerClicked.value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                color: "red-darken-2",
                size: "50px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-close-circle-outline")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, {
            class: _normalizeClass([{
            'green-border': correctAnswerClicked.value,
            'red-border': incorrectAnswerClicked.value,
          }, "my-card mt-3 mb-3"]),
            variant: "elevated",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { style: {"display":"flex","justify-content":"end","padding":"6px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    rotate: 360,
                    size: 60,
                    width: 6,
                    "model-value": topicProgressPercentage.value,
                    color: isSchoolUser.value ? '#FEC331' : '#9575CD'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(topicProgressPercentage.value) + "% ", 1)
                    ]),
                    _: 1
                  }, 8, ["model-value", "color"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", null, _toDisplayString(word.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { style: {"display":"flex","flex-wrap":"wrap","justify-content":"space-between","width":"100%"} }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttonList, (button) => {
                    return _createVNode(_component_v_btn, {
                      key: button.value.id,
                      onClick: ($event: any) => (checkAnswer(button.value)),
                      class: _normalizeClass([{
                'correct-answer':
                  correctAnswerClicked.value && button.value.id === correctAnswer.value,
                'my-btn-disabled':
                  clickedButton.value && button.value.id !== correctAnswer.value,
                'highlight-correct':
                  correctAnswer.value && button.value.id === correctAnswer.value,
              }, "my-btn"]),
                      variant: "tonal",
                      disabled: 
                correctAnswerClicked.value && button.value.id !== correctAnswer.value
              
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.value.value), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class", "disabled"])
                  }), 64))
                ]),
                _: 1
              }),
              (incorrectAnswerClicked.value || correctAnswerClicked.value)
                ? (_openBlock(), _createBlock(_component_v_card_actions, {
                    key: 0,
                    style: {"display":"flex","justify-content":"end"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: fetchNewWord,
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("wordsView.next")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/course",
              class: "mr-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("wordsView.topics")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: _unref(courseType) === 'LANGUAGE_LEVEL' ? '/courses' : '/exercises',
              class: "mr-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(courseType) === "LANGUAGE_LEVEL"
                ? _ctx.$t("wordsView.courses")
                : _ctx.$t("wordsView.exercises")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})